import { openBlock as a, createElementBlock as r, normalizeClass as n, renderSlot as c } from "vue";
import { _ as s } from "./_plugin-vue_export-helper-dad06003.js";
const o = {
  name: "BadgeStatusSm",
  props: {
    type: {
      type: String,
      default: "neutral"
    }
  }
};
function d(t, g, e, l, m, u) {
  return a(), r("p", {
    class: n(["ct-badge-sm", {
      "ct-badge-error": e.type === "error",
      "ct-badge-warning": e.type === "warning",
      "ct-badge-success": e.type === "success",
      "ct-badge-gray": e.type === "neutral",
      "ct-badge-orange": e.type === "orange"
    }])
  }, [
    c(t.$slots, "default")
  ], 2);
}
const f = /* @__PURE__ */ s(o, [["render", d]]);
export {
  f as B
};
